export const PAGE_VIEWED = "pageViewed";
export const DEFAULT_CURRENCY = "EUR";
